import type { createRouter } from '@tanstack/react-router'

type ViewTransitionOptions = Exclude<NonNullable<Parameters<typeof createRouter>[0]['defaultViewTransition']>, boolean>

const ORDER = ['/', '/daily-card', '/deck', '/history', '/auth']

const rank = (pathname: string | undefined) => (pathname === undefined ? -1 : ORDER.indexOf(pathname))

export const screenTransition: ViewTransitionOptions = {
  types: ({ fromLocation, toLocation, pathChanged }) => {
    if (!pathChanged) return false
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false
    const from = rank(fromLocation?.pathname)
    const to = rank(toLocation.pathname)
    if (from < 0 || to < 0) return ['screen-fade']
    return [to > from ? 'screen-forward' : 'screen-back']
  },
}
